import React from "react";
import {
  Avatar,
  Box,
  Button,
  Chip,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import WorkspacePremiumOutlinedIcon from "@mui/icons-material/WorkspacePremiumOutlined";

import  bg from "../../../Logos/med_background2.png"


const ProfileHeader = ({ user, onEdit }) => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const initials = () => {
    if (!user?.name) return "A";

    return user.name
      .split(" ")
      .map((word) => word[0])
      .join("")
      .substring(0, 2)
      .toUpperCase();
  };

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        borderRadius: 5,
         backgroundImage: `
            linear-gradient(135deg, rgba(0,109,119,0.9) 0%, rgba(0, 169, 181, 0.68) 100%),
            url(${bg})
            `,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
           
          position: "relative",
        color: "#fff",
        p: {
          xs: 3,
          md: 5,
        },
        boxShadow: "0 12px 35px rgba(0,109,119,.18)",
      }}
    >
      {/* Decorative circles */}

      <Box
        sx={{
          position: "absolute",
          width: 240,
          height: 240,
          borderRadius: "50%",
          bgcolor: "rgba(255,255,255,.08)",
          top: -80,
          right: -60,
        }}
      />

      <Box
        sx={{
          position: "absolute",
          width: 140,
          height: 140,
          borderRadius: "50%",
          bgcolor: "rgba(255,255,255,.06)",
          bottom: -40,
          left: -30,
        }}
      />

      <Stack
        direction={isMobile ? "column" : "row"}
        spacing={4}
        alignItems={isMobile ? "center" : "center"}
        justifyContent="space-between"
        sx={{
          position: "relative",
          zIndex: 2,
        }}
      >
        {/* LEFT */}

        <Stack
          direction={isMobile ? "column" : "row"}
          spacing={3}
          alignItems="center"
        >
          <Avatar
            src={user?.avatar}
            sx={{
              width: 100,
              height: 100,
              fontSize: 36,
              fontWeight: 700,
              bgcolor: "#ffffff",
              color: "#006D77",
              border: "4px solid rgba(255,255,255,.3)",
            }}
          >
            {initials()}
          </Avatar>

          <Box textAlign={isMobile ? "center" : "left"}>
            <Typography
              variant="h4"
              fontWeight={700}
            >
              {user?.name || "User"}
            </Typography>

            <Stack
              spacing={1}
              mt={2}
            >
              <Stack
                direction="row"
                spacing={1}
                justifyContent={isMobile ? "center" : "flex-start"}
                alignItems="center"
              >
                <PhoneOutlinedIcon fontSize="small" />

                <Typography variant="body2">
                  {user?.phone || "-"}
                </Typography>
              </Stack>

              <Stack
                direction="row"
                spacing={1}
                justifyContent={isMobile ? "center" : "flex-start"}
                alignItems="center"
              >
                <EmailOutlinedIcon fontSize="small" />

                <Typography variant="body2">
                  {user?.email || "-"}
                </Typography>
              </Stack>
            </Stack>

            <Chip
              icon={
                <WorkspacePremiumOutlinedIcon
                  sx={{
                    color: "#FFD54F !important",
                  }}
                />
              }
              label="Ayuja Member"
              sx={{
                mt: 2,
                bgcolor: "rgba(255,255,255,.15)",
                color: "#fff",
                border: "1px solid rgba(255,255,255,.25)",
                fontWeight: 600,
              }}
            />
          </Box>
        </Stack>

        {/* RIGHT */}

        <Stack
          spacing={2}
          alignItems={isMobile ? "stretch" : "flex-end"}
        >
          <Button
            variant="contained"
            startIcon={<EditOutlinedIcon />}
            onClick={onEdit}
            sx={{
              bgcolor: "#fff",
              color: "#006D77",
              px: 3,
              py: 1.2,
              fontWeight: 700,
              borderRadius: 3,
              textTransform: "none",
              minWidth: 170,
              "&:hover": {
                bgcolor: "#f5f5f5",
              },
            }}
          >
            Edit Profile
          </Button>

          <Typography
            variant="body2"
            sx={{
              opacity: 0.9,
              maxWidth: 260,
              textAlign: isMobile ? "center" : "right",
            }}
          >
            Manage your profile, family members, Diagnostic reports,
            prescriptions, rewards and more.
          </Typography>
        </Stack>
      </Stack>
    </Box>
  );
};

export default ProfileHeader;